export default __webpack_public_path__ + "static/media/flower-5.b80b892a.svg";